"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
Object.defineProperty(exports, "TitleEscrowSignable__factory", {
  enumerable: true,
  get: function get() {
    return _TitleEscrowSignable__factory.TitleEscrowSignable__factory;
  }
});
Object.defineProperty(exports, "TradeTrustTokenStandard__factory", {
  enumerable: true,
  get: function get() {
    return _TradeTrustTokenStandard__factory.TradeTrustTokenStandard__factory;
  }
});

var _TitleEscrowSignable__factory = require("./TitleEscrowSignable__factory");

var _TradeTrustTokenStandard__factory = require("./TradeTrustTokenStandard__factory");